import axios from "axios";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Table, Modal, Form, Row, Col, Card } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactTable from 'react-table';
import { getItems, getPrices } from '../../actions/index';
import { BASE_URL, HEADER_OPTIONS_AUTH } from "../lib/basic";
import { openNotificationWithIcon } from "../lib/utils";
import { Spin } from "antd";
import formatNumber from "../lib/formatNumber";
import "react-datepicker/dist/react-datepicker.css";

// Add custom styles for date picker
import './datepicker.css';

// Custom styles for a more modern look
const styles = {
  container: {
    textAlign: 'left',
    width: '100%',
    padding: '20px',
    backgroundColor: '#f5f7f8'
  },
  title: {
    fontSize: '28px',
    fontWeight: '500',
    marginBottom: '20px',
    color: '#1a1a1a',
    textAlign: 'center'
  },
  filterSection: {
    marginBottom: '25px',
    padding: '0',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    overflow: 'hidden'
  },
  filterHeader: {
    backgroundColor: '#f8f9fa',
    padding: '15px 20px',
    borderBottom: '1px solid #eee'
  },
  filterBody: {
    padding: '20px 10px',
    position: 'relative',
    zIndex: 1
  },
  filterTitle: {
    fontSize: '16px',
    fontWeight: '600',
    margin: '0',
    color: '#333',
    textAlign: 'left'
  },
  formLabel: {
    textAlign: 'left',
    display: 'block', 
    fontSize: '14px', 
    fontWeight: '500', 
    marginBottom: '8px',
    color: '#555'
  },
  button: {
    borderRadius: '4px',
    padding: '8px 15px',
    width: '100%',
    fontWeight: '200',
    transition: 'all 0.2s ease',
    boxShadow: 'none',
    fontSize: '14px'
  },
  primaryButton: {
    backgroundColor: '#4361ee',
    borderColor: '#4361ee',
    color: '#fff'
  },
  secondaryButton: {
    backgroundColor: '#f5f5f5',
    borderColor: '#e0e0e0',
    color: '#333'
  },
  formControl: {
    borderRadius: '4px',
    border: '1px solid #ddd',
    padding: '8px 12px',
    fontSize: '14px',
    height: '38px',
    
  },
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    overflow: 'hidden'
  },
  tableHeader: {
    backgroundColor: '#fff',
    fontWeight: '600',
    padding: '15px 20px',
    fontSize: '13px',
    color: '#555',
    textTransform: 'uppercase',
    borderBottom: '1px solid #eee'
  },
  tableCell: {
    padding: '15px 20px',
    fontSize: '14px',
    color: '#333',
    borderBottom: '1px solid #eee'
  },
  successTag: {
    color: '#10b981',
    fontWeight: '600'
  },
  invoicedTag: {
    color: '#555',
    fontWeight: '500'
  },
  pagination: {
    marginTop: '25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  pageInfo: {
    color: '#666',
    fontSize: '14px'
  },
  stats: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 20px',
    color: '#666',
    fontSize: '14px',
    borderTop: '1px solid #eee'
  },
  datePicker: {
    width: '100%'
  },
  modal: {
    borderRadius: '8px'
  },
  modalHeader: {
    borderBottom: '1px solid #f0f0f0',
    padding: '15px 20px'
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '500'
  },
  modalBody: {
    padding: '20px'
  },
  modalFooter: {
    borderTop: '1px solid #f0f0f0',
    padding: '15px 20px'
  },
  paginationButton: {
    backgroundColor: '#e9ecfb',
    borderColor: '#e9ecfb',
    color: '#4361ee',
    borderRadius: '4px',
    padding: '8px 16px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    boxShadow: 'none'
  },
  filterButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '10px'
  }
};

export const TaskItem = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector(state => state.authenticated);
    const processItems = useSelector(state => state.processItems);
    const companies = useSelector(state => state.companies);
    const [showDownload, setShowDownload] = useState(false);
    const [startDate, setStartDate] = useState(moment().toDate());
    const [endDate, setEndDate] = useState(moment().toDate());
    const [optionList, setOptionList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [clients, setClients] = useState([]);
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    
    console.log("companines",companies);
    // Filter states
    const [filterStartDate, setFilterStartDate] = useState(null);
    const [filterEndDate, setFilterEndDate] = useState(null);
    const [filterCompany, setFilterCompany] = useState("default");
    const [filteredData, setFilteredData] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);
    const [totalFilteredItems, setTotalFilteredItems] = useState(0);
    const [totalFilteredPages, setTotalFilteredPages] = useState(0);

    // Load initial data when component mounts or user/page changes
    useEffect(() => {
        if (!user || (user.role !== "superAdmin" && user.role !== "admin" && user.role !== "businessRep")) {
            history.push('/');
        } else {
            if (!isFiltered) {
                loadItems(currentPage);
            }
        }
    }, [user, history, currentPage, isFiltered]);

    // Load companies for the dropdown
    useEffect(() => {
        const fetchCompanies = async () => {
            const response = await axios.get(`${BASE_URL}/client`, HEADER_OPTIONS_AUTH(user.token));
            console.log("response",response);
            if (response.status === 200) {
                const companies = response.data.data;
                setClients(companies);
            }
        };
        fetchCompanies();
    }, [companies]);

    // Function to load items from API with pagination
    const loadItems = async (page) => {
        setLoader(true);
        try {
            await Promise.all([
                getItems(user, dispatch, page, itemsPerPage),
                getPrices(user, dispatch)
            ]);
        } catch (error) {
            openNotificationWithIcon("error", "Failed to load items");
            console.error("Error loading items:", error);
        } finally {
            setLoader(false);
        }
    };

    // Pagination controls - handle differently based on filter state
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newPage = currentPage - 1;
            setCurrentPage(newPage);
            if (isFiltered) {
                // When filtered, we need to fetch filtered data for the new page
                applyFiltersForPage(newPage);
            }
        }
    };

    const handleNextPage = () => {
        const totalPages = isFiltered 
            ? totalFilteredPages 
            : (processItems?.pagination?.totalPages || 1);
            
        if (currentPage < totalPages) {
            const newPage = currentPage + 1;
            setCurrentPage(newPage);
            if (isFiltered) {
                // When filtered, we need to fetch filtered data for the new page
                applyFiltersForPage(newPage);
            }
        }
    };

    // Separate function to apply filters for a specific page
    const applyFiltersForPage = async (page) => {
        if (!user) return;
        
        setLoader(true);
        
        try {
            const options = HEADER_OPTIONS_AUTH(user.token);
            
            // Build filter parameters
            const params = {
                page: page,
                limit: itemsPerPage
            };
            
            if (filterCompany && filterCompany !== "default") {
                params.companyId = filterCompany;
            }
            
            if (filterStartDate) {
                params.startDate = moment(filterStartDate).format('YYYY-MM-DD');
            }
            
            if (filterEndDate) {
                params.endDate = moment(filterEndDate).format('YYYY-MM-DD');
            }
            
            // Make API call with filters
            const response = await axios.get(`${BASE_URL}/process_recordBasedOnFilter`, { 
                params,
                ...options 
            });
            
            if (response.data && response.status === 200) {
                console.log("response.data.data", response.data);
                setFilteredData(response.data.data.items);
                setTotalFilteredItems(response.data.data.pagination?.totalItems || 0);
                setTotalFilteredPages(response.data.data.pagination?.totalPages || 1);
            } else {
                openNotificationWithIcon("error", "Failed to filter items");
            }
        } catch (error) {
            const errorMsg = error.response ? error.response.data.message : error.request ? "No internet!" : error.message;
            openNotificationWithIcon("error", errorMsg);
            console.error("Filter error:", error);
        } finally {
            setLoader(false);
        }
    };

    // Function to apply filters using API call
    const applyFilters = async () => {
        if (!user) return;
        
        setLoader(true);
        setIsFiltered(true);
        // Reset to page 1 when applying new filters
        setCurrentPage(1);
        
        try {
            const options = HEADER_OPTIONS_AUTH(user.token);
            
            // Build filter parameters
            const params = {
                page: 1, // Always start with page 1 for new filters
                limit: itemsPerPage
            };
            
            if (filterCompany && filterCompany !== "default") {
                params.companyId = filterCompany;
            }
            
            if (filterStartDate) {
                params.startDate = moment(filterStartDate).format('YYYY-MM-DD');
            }
            
            if (filterEndDate) {
                params.endDate = moment(filterEndDate).format('YYYY-MM-DD');
            }
            
            // Make API call with filters
            const response = await axios.get(`${BASE_URL}/process_recordBasedOnFilter`, { 
                params,
                ...options 
            });
            
            if (response.data && response.status === 200) {
                console.log("response.data.data", response.data);
                setFilteredData(response.data.data.items);
                setTotalFilteredItems(response.data.data.pagination?.totalItems || 0);
                setTotalFilteredPages(response.data.data.pagination?.totalPages || 1);
            } else {
                openNotificationWithIcon("error", "Failed to filter items");
            }
        } catch (error) {
            const errorMsg = error.response ? error.response.data.message : error.request ? "No internet!" : error.message;
            openNotificationWithIcon("error", errorMsg);
            console.error("Filter error:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleDownloadShow = () => {
        setShowDownload(true);
    };

    const handleChangeStartDate = (date) => {
        setStartDate(date);
    };

    const handleChangeEndDate = (date) => {
        setEndDate(date);
    };

    const handleClose = () => {
        setStartDate(moment().toDate());
        setEndDate(moment().toDate());
        setShowDownload(false);
    };

    const handleDownloadReport = async () => {
        const options = HEADER_OPTIONS_AUTH(user.token);
        options.responseType = 'blob';
        const data = {
            "companyID": filterCompany,
            "startDate": moment(startDate).format('YYYY-MM-DD'),
            "endDate": moment(endDate).format('YYYY-MM-DD'),
        };
        try {
            const response = await axios.post(`${BASE_URL}/download-processed-item-report`, data, options);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Inflators_processed_report.xlsx`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            const errorMsg = error.response ? error.response.data.message : error.request ? "No internet!" : error.message;
            openNotificationWithIcon("error", errorMsg);
        }
    };

    // Reset all filters and go back to unfiltered view
    const handleResetFilters = () => {
        setFilterStartDate(null);
        setFilterEndDate(null);
        setFilterCompany("default");
        setIsFiltered(false);
        setFilteredData([]);
        setCurrentPage(1); // Reset to first page
        
        // Reload unfiltered data for page 1
        loadItems(1);
    };

    // Handle filter submission
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        applyFilters();
    };

    // Custom table component to match the design
    const renderCustomTable = () => {
        // Determine which data to use
        const data = isFiltered ? filteredData : (processItems?.items || []);
        
        if (!data.length) {
            return (
                <div style={{padding: '30px', textAlign: 'center', color: '#888', backgroundColor: '#fff', borderRadius: '8px'}}>
                    No data available
                </div>
            );
        }
        
        return (
            <div style={styles.tableContainer}>
                <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                        <tr>
                            <th style={styles.tableHeader}>COMPANY NAME</th>
                            <th style={styles.tableHeader}>BAR CODE</th>
                            <th style={styles.tableHeader}>RECEIVED DATE</th>
                            <th style={styles.tableHeader}>PROCESSED DATE</th>
                            <th style={styles.tableHeader}>STATUS</th>
                            <th style={styles.tableHeader}>BILLING STATUS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td style={styles.tableCell}>{item.companyName}</td>
                                <td style={styles.tableCell}>{item.barCode}</td>
                                <td style={styles.tableCell}>{item.receivedDate ? item.receivedDate.slice(0, 10) : '-'}</td>
                                <td style={styles.tableCell}>{item.processDate ? item.processDate.slice(0, 10) : 'NOT RECEIVED'}</td>
                                <td style={styles.tableCell}>
                                    <span style={styles.successTag}>
                                        {item.status === 'UNSUCCESSFULLY_DEACTIVATED' ? 'FAILED' : item.status}
                                    </span>
                                </td>
                                <td style={styles.tableCell}>
                                    <span style={styles.invoicedTag}>{item.billing_status}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                
                <div style={styles.stats}>
                    <div>
                        Showing {data.length} records
                        {isFiltered && totalFilteredItems > 0 && ` (filtered from ${totalFilteredItems})`}
                    </div>
                    <div>
                        Total Pages: {formatNumber(isFiltered ? totalFilteredPages : (processItems?.pagination?.totalPages || 1))}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Item Record</h1>

            {/* Filter controls */}
            <Card style={styles.filterSection}>
                
                <Form onSubmit={handleFilterSubmit}>
                    <div style={styles.filterBody}>
                        <Row style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <Col lg={3} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label style={styles.formLabel}>
                                        Company
                                    </Form.Label>
                                    {/* Using companyId as the value instead of companyName for API filtering */}
                                    <Form.Control 
                                        as="select" 
                                        value={filterCompany}   
                                        onChange={(e) => {
                                           
                                            setFilterCompany(e.target.value);
                                        }}
                                        style={styles.formControl}
                                    >
                                        <option value="default">All Companies</option>
                                        {clients && clients.map((company) => (
                                            <option key={company.companyID} value={company.companyID}>{company.companyName}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label style={styles.formLabel}>
                                        Start Date
                                    </Form.Label>
                                    <DatePicker
                                        selected={filterStartDate}
                                        onChange={date => setFilterStartDate(date)}
                                        selectsStart
                                        startDate={filterStartDate}
                                        endDate={filterEndDate}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="mm/dd/yyyy"
                                        className="form-control"
                                        customInput={<Form.Control style={styles.formControl} />}
                                        popperProps={{
                                            positionFixed: true
                                        }}
                                        popperModifiers={{
                                            preventOverflow: {
                                                enabled: true,
                                                escapeWithReference: false,
                                                boundariesElement: 'viewport'
                                            }
                                        }}
                                        portalId="date-picker-portal"
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label style={styles.formLabel}>
                                        End Date
                                    </Form.Label>
                                    <DatePicker
                                        selected={filterEndDate}
                                        onChange={date => setFilterEndDate(date)}
                                        selectsEnd
                                        startDate={filterStartDate}
                                        endDate={filterEndDate}
                                        minDate={filterStartDate}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="mm/dd/yyyy"
                                        className="form-control"
                                        customInput={<Form.Control style={styles.formControl} />}
                                        popperProps={{
                                            positionFixed: true
                                        }}
                                        popperModifiers={{
                                            preventOverflow: {
                                                enabled: true,
                                                escapeWithReference: false,
                                                boundariesElement: 'viewport'
                                            }
                                        }}
                                        portalId="date-picker-portal"
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={3} md={6} className="mb-3 d-flex align-items-end">
                                
                                <Button 
                                    variant="primary"
                                    type="submit"
                                    style={{...styles.button, ...styles.primaryButton, marginRight: '10px'}}
                                >
                                    <i className="fas fa-search mr-1" style={{marginRight: '5px'}}></i>
                                    Apply Filters
                                </Button>
                                <Button 
                                    variant="light" 
                                    onClick={handleResetFilters}
                                    style={{...styles.button, ...styles.secondaryButton, marginRight: '10px'}}
                                    type="button"
                                >
                                    <i className="fas fa-sync-alt mr-1" style={{marginRight: '5px'}}></i>
                                    Reset Filters
                                </Button>
                                <Button 
                                    variant="primary" 
                                    onClick={handleDownloadShow} 
                                    style={{...styles.button, ...styles.primaryButton, width: "40rem"}}
                                    type="button"
                                >
                                    <i className="fa fa-download mr-1"
                                     style={{marginRight: '5px'}}
                                     ></i>
                                    Download Report
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Card>

            {/* Modal code for downloading */}
            <Modal 
                backdrop="static" 
                show={showDownload} 
                onHide={handleClose} 
                centered 
                dialogClassName={'user-modal'}
                style={styles.modal}
            >
                <Modal.Header closeButton style={styles.modalHeader}>
                    <Modal.Title style={styles.modalTitle}>Process Record Download</Modal.Title>
                </Modal.Header>
                <Modal.Body style={styles.modalBody}>
                    {loader ? <Spin size="large" /> : (
                        <Table responsive bordered={true} style={{ marginBottom: '0px' }}>
                            <tbody>
                                <tr>
                                    <th>Start Date</th>
                                    <td>
                                        <DatePicker 
                                            selected={startDate} 
                                            onChange={handleChangeStartDate} 
                                            className="form-control"
                                            dateFormat="MM/dd/yyyy"
                                            customInput={<Form.Control style={styles.formControl} />}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>End Date</th>
                                    <td>
                                        <DatePicker 
                                            selected={endDate} 
                                            onChange={handleChangeEndDate} 
                                            className="form-control"
                                            dateFormat="MM/dd/yyyy"
                                            customInput={<Form.Control style={styles.formControl} />}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    )}
                </Modal.Body>
                <Modal.Footer style={styles.modalFooter}>
                    <Button variant="light" onClick={handleClose} style={{...styles.button, ...styles.secondaryButton}}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleDownloadReport} style={{...styles.button, ...styles.primaryButton}}>
                        Download Report
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Loader or Table */}
            {loader ? (
                <div style={{display: 'flex', justifyContent: 'center', padding: '50px', backgroundColor: '#fff', borderRadius: '8px'}}>
                    <Spin size="large" />
                </div>
            ) : (
                <>
                    {renderCustomTable()}
                    
                    {/* Pagination Controls */}
                    <div style={styles.pagination}>
                        <div style={styles.pageInfo}>
                            Showing {isFiltered ? filteredData.length : (processItems?.items?.length || 0)} records 
                            {isFiltered && totalFilteredItems > 0 && ` (filtered from ${totalFilteredItems})`}
                        </div>
                        
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Button 
                                variant="light" 
                                onClick={handlePreviousPage} 
                                disabled={currentPage === 1}
                                style={styles.paginationButton}
                            >
                                <i className="fas fa-chevron-left mr-1"></i> Previous
                            </Button>
                            <span style={{margin: '0 15px'}}>
                                Page {currentPage} of {
                                    isFiltered 
                                    ? formatNumber(totalFilteredPages) 
                                    : formatNumber(processItems?.pagination?.totalPages || 1)
                                }
                            </span>
                            <Button 
                                variant="light" 
                                onClick={handleNextPage} 
                                disabled={currentPage === (
                                    isFiltered 
                                    ? totalFilteredPages 
                                    : (processItems?.pagination?.totalPages || 1)
                                )}
                                style={styles.paginationButton}
                            >
                                Next <i className="fas fa-chevron-right ml-1"></i>
                            </Button>
                        </div>
                        
                        <div style={styles.pageInfo}>
                            Total Pages: {
                                formatNumber(
                                    isFiltered 
                                    ? totalFilteredPages 
                                    : (processItems?.pagination?.totalPages || 0)
                                )
                            }
                        </div>
                    </div>
                </>
            )}

            {/* Date Picker Portal for proper rendering */}
            <div id="date-picker-portal"></div>
        </div>
    );
};
